import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor() { }

  findCookieValue(cookieName: string): string | boolean {
    const cookies = document.cookie.split(/; */);

    for (let cookie in cookies) {
      const name = cookies[cookie].substr(0, cookies[cookie].indexOf('='));
      if (name === cookieName) {
        return cookies[cookie].substr(name.length + 1);
      }
    }
    return false;
  }

  setCookieValue(cookieName: string, cookieValue: string, days: number = 0): void {
    if (days > 0) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = `${cookieName}=${cookieValue}; expires=${date}; path=/;`;
    }
    else {
      document.cookie = `${cookieName}=${cookieValue}; path=/;`;
    }
  }

}

